import React from 'react';
import { PS } from '../theme';
import { Icon } from '../lib/icons';
import MemberLayout from './MemberLayout';
import Screen from './Screen';
import { useAuth } from '../auth/AuthContext';

export default function GuestGate({ icon = 'lock', title, message, layout = 'tab', testid = 'guest-gate' }) {
  const { login } = useAuth();
  const IcoC = Icon[icon] || Icon.lock;
  const Wrap = layout === 'tab' ? MemberLayout : Screen;
  return (
    <Wrap>
      <div data-testid={testid} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '0 32px', gap: 14 }}>
        <div style={{ width: 64, height: 64, borderRadius: 20, background: PS.panel, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <IcoC size={28} stroke={PS.ink} />
        </div>
        <div style={{ fontSize: 20, fontWeight: 700, letterSpacing: -0.3 }}>{title}</div>
        <div style={{ fontSize: 13.5, color: PS.textMuted, lineHeight: 1.6, maxWidth: 300 }}>{message}</div>
        <button data-testid={`${testid}-login-btn`} onClick={login} className="ps-press" style={{ marginTop: 6, height: 50, padding: '0 28px', background: PS.ink, color: PS.page, border: 'none', borderRadius: 25, fontSize: 14.5, fontWeight: 600, fontFamily: PS.fontUI, display: 'flex', alignItems: 'center', gap: 8 }}>
          เข้าสู่ระบบด้วย Google <Icon.chevronR size={15} stroke={PS.page} />
        </button>
        <div style={{ fontSize: 11.5, color: PS.textDim, marginTop: 2 }}>ฟรี · ไม่ต้องผูกบัตร · ศึกษาข้อมูลได้โดยไม่ต้องสมัคร</div>
      </div>
    </Wrap>
  );
}
